import Challenges from './challenges'

export default Challenges